import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { splitGifts } from "~/utils/cartGifts";
import CartGift from "~/components/common/cartGift";
import { getBacket } from "../../../redux/action-creaters/basket";
import styles from "./index.module.scss";
import Button from "/components/common/button";
import { showPopup } from "../../../redux/action-creaters/popup";
import { popupTypes } from "../../../redux/reducers/popupReducer";
import BasketItems from "/components/common/basketItems";
import { declOfNum, formatPrice } from "../../../utils";

export default function Cart() {
  const router = useRouter();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBacket(true));
  }, []);

  const { basket } = useSelector((state) => state.cart);

  const sum = useMemo(() => {
    return basket?.PRICE;
  }, [basket]);

  return (
    <div className={styles.Basket} data-test="addToCartPopup">
      <h2>Товар добавлен в корзину</h2>
      <BasketItems />
      <CartGift items={splitGifts(basket).gifts} />
      <div className={styles.Total}>
        <div className={styles.TotalItem}>
          <div>
            В корзине{" "}
            {declOfNum(splitGifts(basket).qty, ["товар", "товара", "товаров"])}
          </div>
          <span>на сумму {formatPrice(sum)} руб</span>
        </div>
        <div className={styles.TotalButtons}>
          <Button
            onClick={() => {
              dispatch(showPopup(popupTypes.none));
            }}
            type={"outline"}
            label={"Продолжить покупки"}
          />
          <Button
            test="goToCartButton"
            onClick={() => {
              router.push("/personal/cart/");
            }}
            label={"Оформить заказ"}
          />
        </div>
      </div>
    </div>
  );
}
